<script setup lang="ts">
import type { BarometerCar, DetailsCarItemData } from '@autobid/ui/types/Car'
import { useAuction } from '@autobid/ui/composables/useAuction'
import { useAuctionId } from '@autobid/ui/composables/useAuctionId'
import { useAuctionPagesLink } from '@autobid/ui/composables/useAuctionPagesLink'
import { useGetTypeOfPrevPage } from '@autobid/ui/composables/useGetTypeOfPrevPage'
import { computed, watch } from 'vue'

interface Props {
  car: DetailsCarItemData | BarometerCar
}

const props = defineProps<Props>()
const router = useRouter()
const auctionId = useAuctionId()

const carStage = computed(() => props.car.stage)
const { t } = useI18n()
const push = usePush()
const { getTypeOfPrevPage } = useGetTypeOfPrevPage()
const { getLink } = useAuctionPagesLink()
const { auction } = useAuction(auctionId)
const { locale } = useI18n()
const auctionLink = computed(() =>
  auction.value?.slug
    ? getLink({
        page: 'car-list',
        slug: auction.value.slug,
      })
    : `/${locale.value}`,
)

function redirectIfCarRemoved() {
  push.warning(t('shared-car.car-has-been-removed-toast'))

  const typeOfPrevPage = getTypeOfPrevPage()

  if (typeOfPrevPage === 'cms') {
    router.back()
  }
  else {
    router.replace({ path: auctionLink.value })
  }
}

watch(carStage, (newVal, oldVal) => {
  if (oldVal && newVal === 'REMOVED') {
    redirectIfCarRemoved()
  }
})
</script>

<template>
  <div class="w-full">
    <div v-if="car.publicationInfo.status === 'WITHDRAW'">
      <autobid-page
        :slug="
          auction?.stage === 'FINISHED'
            ? 'auction-in-preparation-finished'
            : 'auction-in-preparation'
        "
        :allow-empty="true"
        ignore-blacklist
      >
        <template #default="{ pageData }">
          <CommonStrapiPage v-if="pageData?.page" :page-data="pageData" />

          <SectionsAuctionInPreparationInfo v-else />
        </template>
      </autobid-page>
    </div>
    <div v-else-if="typeof auctionId === 'number'" class="w-full">
      <sections-auction-layout-middleware :auction-id="auctionId">
        <slot name="default" />
      </sections-auction-layout-middleware>
    </div>
    <div v-else class="py-4 container px-2">
      <p class="text-xl">
        {{ $t('unexpected-error') }}
      </p>
      
    </div>
  </div>
</template>
